export const getStandardHeaders = () => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json; charset=utf-8');
  return headers;
};

export interface SimInventoryBaseErrorReturn {
  error: string;
  statusCode: number;
}
export interface ApiBaseError extends Error {
  info?: SimInventoryBaseErrorReturn;
  status?: number;
}
